"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var AppPaySystemWalletEditor_1 = require("./component/AppPaySystemWalletEditor");
var AppPaySystemWalletsList_1 = require("./component/AppPaySystemWalletsList");
var AppPaySystemWalletOperationsConfig_1 = require("./component/AppPaySystemWalletOperationsConfig");
var PAppPaySystemWalletsList = /** @class */ (function (_super) {
    __extends(PAppPaySystemWalletsList, _super);
    function PAppPaySystemWalletsList(props) {
        return _super.call(this, props) || this;
    }
    PAppPaySystemWalletsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_CT = this.props.cryptoCurrencyTypesList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_cryptocurrency: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.cryptoCurrencyTypesList.LoadData();
        });
    };
    PAppPaySystemWalletsList.prototype.componentWillUnmount = function () {
        this.props.cryptoCurrencyTypesList.UnSubscribe(this.SID_CT);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PAppPaySystemWalletsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PAppPaySystemWalletsList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PAppPaySystemWalletsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PAppPaySystemWalletsList.prototype.onConfigClick = function (id) {
        this.setState({ edit_mode: "CONFIG", record: id });
    };
    PAppPaySystemWalletsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PAppPaySystemWalletsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(AppPaySystemWalletEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availWalletCurrencyTypes: this.state.avail_cryptocurrency }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(AppPaySystemWalletEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availWalletCurrencyTypes: this.state.avail_cryptocurrency }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(AppPaySystemWalletsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onConfigClick: this.onConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(AppPaySystemWalletOperationsConfig_1.default, { dataWalletLocks: this.props.dataWalletLocks, state: this.props.state, dataWalletReceives: this.props.dataWalletReceives, onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PAppPaySystemWalletsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PAppPaySystemWalletsList.getPageDescription = function (state) {
        return {
            icon: "wallet",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_paysystem_wallets + "-id",
            itemTitle: "Кошельки",
            route: routes_1.routes.page_paysystem_wallets,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PAppPaySystemWalletsList;
}(React.Component));
exports.default = PAppPaySystemWalletsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ui/PAppPaySystemWalletsList.tsx
// module id = 2562
// module chunks = 0